<div *ngIf="floors.length > 0" class="floor-selector">
  <button class="floor-pill all-floors" [class.active]="selectedFloors.size === floors.length" (click)="selectAllFloors()">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
      <rect x="4" y="4" width="16" height="4" rx="2" fill="currentColor"/>
      <rect x="6" y="10" width="12" height="4" rx="2" fill="currentColor"/>
      <rect x="8" y="16" width="8" height="4" rx="2" fill="currentColor"/>
    </svg>
    <span>All floors</span>
  </button>
  <span class="floor-divider"></span>
  <div class="floor-numbers">
    <button *ngFor="let floor of floors" class="floor-pill floor-number" [class.active]="isFloorSelected(floor)" (click)="toggleFloor(floor)">
      {{ floor }}
    </button>
  </div>
</div>

<div #containerEl *ngIf="config" class="viewer-container"
     [class.is-panning]="isPanning"
     [class.has-highlight]="highlightedTicketTypeIds.length > 0"
     [class.legend-open]="isLegendOpen"
     (mousemove)="onContainerMouseMove($event)"
     (mouseleave)="onSeatMouseLeave()"
     (click)="onContainerClick($event)">

  <!-- Reset zoom button -->
  <button class="reset-view-btn" (click)="resetView()" title="Reset view">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
      <path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-208 176a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"/>
      <rect fill="currentColor" x="120" y="184" width="176" height="48" rx="24"/>
    </svg>
  </button>

  <svg #svgEl [attr.viewBox]="viewBox" preserveAspectRatio="xMidYMid meet">
    <!-- Background Image -->
    <image *ngIf="config.backgroundImageURI"
           [attr.href]="config.backgroundImageURI"
           [attr.x]="config.backgroundImageX || 0"
           [attr.y]="config.backgroundImageY || 0"
           [attr.width]="1000 * (config.backgroundImageScale || 1)"
           [attr.height]="1000 * (config.backgroundImageScale || 1)"
           style="pointer-events: none;" />

    <!-- Blocks -->
    <g *ngFor="let block of config.blocks; trackBy: trackByBlockId"
       [attr.transform]="'translate(' + block.x + ',' + block.y + ') rotate(' + block.rotation + ')'">

      <ng-container *ngFor="let seat of getSeatsForBlock(block); trackBy: trackBySeatId">
        <circle *ngIf="!block.seatShape || block.seatShape === 'circle'"
                [attr.data-seat-id]="seat.id"
                [attr.cx]="seat.x"
                [attr.cy]="seat.y"
                [attr.r]="block.seatSize || 8"
                [class]="'seat ' + getSeatStatus(seat.id) + (!isSeatOnSelectedFloor(seat) ? ' off-floor' : '') + (isTicketTypeHighlighted(seat.ticketTypeId) ? ' highlighted' : '')"
                [attr.fill]="getSeatColor(seat)"
                (touchstart)="toggleSeat($event, seat)"
                (mouseenter)="onSeatMouseEnter($event, seat)"
                (mousemove)="onSeatMouseMove($event)"
                (mouseleave)="onSeatMouseLeave()">
          <title>{{ block.name }} - Row {{ seat.row }}, Seat {{ seat.number }}</title>
        </circle>

        <rect *ngIf="block.seatShape === 'rectangle'"
                [attr.data-seat-id]="seat.id"
                [attr.x]="seat.x - (block.seatSize || 8)"
                [attr.y]="seat.y - (block.seatSize || 8)"
                [attr.width]="(block.seatSize || 8) * 2"
                [attr.height]="(block.seatSize || 8) * 2"
                [class]="'seat ' + getSeatStatus(seat.id) + (!isSeatOnSelectedFloor(seat) ? ' off-floor' : '') + (isTicketTypeHighlighted(seat.ticketTypeId) ? ' highlighted' : '')"
                [attr.fill]="getSeatColor(seat)"
                (touchstart)="toggleSeat($event, seat)"
                (mouseenter)="onSeatMouseEnter($event, seat)"
                (mousemove)="onSeatMouseMove($event)"
                (mouseleave)="onSeatMouseLeave()">
          <title>{{ block.name }} - Row {{ seat.row }}, Seat {{ seat.number }}</title>
        </rect>

        <!-- Wheelchair Icon for Disabled Access Seats -->
        <path *ngIf="block.isDisabledAccessible && getSeatStatus(seat.id) !== 'sold' && getSeatStatus(seat.id) !== 'unavailable'"
              [attr.transform]="'translate(' + seat.x + ',' + seat.y + ') scale(' + (((block.seatSize || 8) * 1.2) / 512) + ') translate(-248, -252)'"
              d="M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm272 368-76.3-138.8c-7.9-14.4-23-23.2-39.3-23.2H240v-80h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24h99.7l54 98.2c7.6 13.9 25.2 18.9 39.1 11.3s18.9-25.2 11.3-39.1zM281.6 376c-17.9 37.9-56.3 64-100.8 64-61.9 0-112-50.1-112-112 0-54.7 39.2-99.8 91.2-109.8 13.1-2.5 21.7-15.2 19.2-28.3s-15.2-21.7-28.3-19.2C71 184.8 16 247.4 16 328c0 97.2 78.8 176 176 176 72.8 0 135.5-44.3 162.7-107.5 5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6z"
              fill="#ffffff"
              style="pointer-events: none;">
        </path>

        <!-- Selection indicator -->
        <path *ngIf="getSeatStatus(seat.id) === 'selected'"
              class="selection-checkmark"
              [attr.transform]="'translate(' + seat.x + ',' + seat.y + ') rotate(' + -(block.rotation || 0) + ')'"
              d="M -4 -1 l 3 3 l 5 -6" />

        <!-- Sold / Unavailable indicator (Cross) -->
        <g *ngIf="getSeatStatus(seat.id) === 'sold' || getSeatStatus(seat.id) === 'unavailable'"
           [attr.transform]="'translate(' + seat.x + ',' + seat.y + ') rotate(' + -(block.rotation || 0) + ')'"
           class="sold-cross">
          <line x1="-3" y1="-3" x2="3" y2="3" />
          <line x1="3" y1="-3" x2="-3" y2="3" />
        </g>
      </ng-container>
    </g>
  </svg>

  <!-- Tooltip -->
  <div *ngIf="hoveredTicketType"
       class="seat-tooltip"
       [class.at-bottom]="tooltipAtBottom"
       [style.left.px]="tooltipPosition.x"
       [style.top.px]="tooltipPosition.y">
    <div class="tooltip-name">{{ hoveredTicketType.label[selectedLanguage] || hoveredTicketType.label }}</div>
    <div class="tooltip-location" *ngIf="hoveredSeat">
      {{ hoveredSeat.blockName }} - Row {{ hoveredSeat.row }}, Seat {{ hoveredSeat.number }}
    </div>
    <div class="tooltip-description" *ngIf="hoveredTicketType.description">
      {{ hoveredTicketType.description[selectedLanguage] || hoveredTicketType.description }}
    </div>
    <div class="tooltip-price">{{ (hoveredTicketType.price | number:'1.2-2') }}€</div>
  </div>

  <!-- Highlight caption -->
  <div *ngIf="highlightedTicketType" class="highlight-caption" [class.applied]="highlightApplied" [class.has-list]="highlightCaptionItems.length > 0">
    <span class="highlight-dot" [style.background-color]="highlightedTicketTypeIds.length > 1 ? 'var(--ion-color-primary)' : highlightedTicketType.color || '#000000'"></span>
    <div class="highlight-text">
      <strong>{{ highlightTitle || highlightedTicketType.label[selectedLanguage] || highlightedTicketType.label }}</strong>
      <span *ngIf="highlightCaption">{{ highlightCaption }}</span>
      <ul *ngIf="highlightCaptionItems.length > 0" class="highlight-list">
        <li *ngFor="let item of highlightCaptionItems">{{ item }}</li>
      </ul>
    </div>
    <button class="highlight-close" (click)="clearHighlight($event)" [attr.aria-label]="highlightCloseLabel" [title]="highlightCloseLabel">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/>
      </svg>
    </button>
  </div>

  <!-- Legend (overlays the top left corner of the map) -->
  <div class="seat-legend" [class.collapsed]="!isLegendOpen">
    <button *ngIf="!isLegendOpen" type="button" class="seat-legend-toggle" (click)="toggleLegend($event)" [attr.aria-label]="'SEAT_MAP_LEGEND.SHOW' | translate" [title]="'SEAT_MAP_LEGEND.SHOW' | translate">
      <span class="seat-legend-toggle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
          <circle cx="5" cy="6" r="2" fill="currentColor"/>
          <circle cx="5" cy="12" r="2" fill="currentColor"/>
          <circle cx="5" cy="18" r="2" fill="currentColor"/>
          <path d="M10 6h10M10 12h10M10 18h10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/>
        </svg>
      </span>
      <span>{{ 'SEAT_MAP_LEGEND.TITLE' | translate }}</span>
    </button>

    <ng-container *ngIf="isLegendOpen">
      <div class="seat-legend-header">
        <strong>{{ 'SEAT_MAP_LEGEND.TITLE' | translate }}</strong>
        <button type="button" class="seat-legend-close" (click)="toggleLegend($event)" [attr.aria-label]="'SEAT_MAP_LEGEND.HIDE' | translate" [title]="'SEAT_MAP_LEGEND.HIDE' | translate">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/>
          </svg>
        </button>
      </div>

      <div class="seat-legend-body">
      <div #legendItemsEl class="seat-legend-items">
        <button *ngFor="let tt of legendTicketTypes; trackBy: trackByTicketTypeId" type="button" class="seat-legend-item"
                [class.highlighted]="isTicketTypeHighlighted(tt.id)"
                [class.dimmed]="highlightedTicketTypeIds.length > 0 && !isTicketTypeHighlighted(tt.id)"
                [attr.aria-pressed]="isTicketTypeHighlighted(tt.id)"
                (click)="onLegendTicketTypeClick($event, tt.id)">
          <span class="dot" [style.background-color]="tt.color || '#000000'"></span>
          <span class="seat-legend-text">
            <span class="seat-legend-name">{{ tt.label[selectedLanguage] || tt.label }}</span>
            <span *ngIf="tt.isFree" class="seat-legend-price">{{ 'TICKET_TYPES.FREE' | translate }}</span>
            <ng-container *ngIf="!tt.isFree && hasLegendPrice(tt)">
              <span *ngIf="tt.lowestPrice !== tt.highestPrice" class="seat-legend-price">{{ 'TICKET_TYPES.FROM' | translate }} {{ tt.lowestPrice | number:'1.2-2' }}€ {{ 'TICKET_TYPES.TO' | translate }} {{ tt.highestPrice | number:'1.2-2' }}€</span>
              <span *ngIf="tt.lowestPrice === tt.highestPrice" class="seat-legend-price">{{ tt.highestPrice | number:'1.2-2' }}€</span>
            </ng-container>
          </span>
        </button>
      </div>
      <!-- Always visible scroll indicator on mobile, where native scrollbars auto-hide -->
      <div class="seat-legend-scrollbar" aria-hidden="true"><div class="seat-legend-scrollbar-thumb"></div></div>
      </div>

      <div class="seat-legend-statuses">
        <span class="seat-legend-status"><span class="dot selected"></span>{{ 'SEAT_MAP_LEGEND.SELECTED' | translate }}</span>
        <span class="seat-legend-status"><span class="dot sold"></span>{{ 'SEAT_MAP_LEGEND.SOLD' | translate }}</span>
        <span class="seat-legend-status" *ngIf="unavailableTicketTypeIds.length > 0"><span class="dot unavailable"></span>{{ 'SEAT_MAP_LEGEND.UNAVAILABLE' | translate }}</span>
      </div>
    </ng-container>
  </div>

  <!-- Zoom hint -->
  <div class="zoom-hint" [class.hidden]="highlightedTicketTypeIds.length > 0">
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 512 512" fill="currentColor">
      <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-208 176a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"/>
    </svg>
    Scroll to zoom · Drag to pan
  </div>
</div>
